import { CalendarDays } from 'lucide-react'
import { useState, type ReactElement } from 'react'

import { Calendar } from '@/components/ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { cn } from '@/lib/cn'
import { parseLocalDate, toDateOnly } from '@/lib/date'

/** 'YYYY-MM-DD' → 'DD/MM/YYYY' sem passar por Date — date-only não tem fuso. */
function diaCurto(dia: string): string {
  const [ano, mes, d] = dia.split('-')
  return `${d}/${mes}/${ano}`
}

function pilula(ativo: boolean): string {
  return cn(
    'min-h-[44px] rounded-full px-3 text-sm font-medium transition-colors sm:min-h-9',
    ativo ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:text-foreground',
  )
}

export interface SeletorDiaApresentacaoProps {
  /** Dia do diário ('YYYY-MM-DD'). Ausente = hoje. */
  dia?: string
  onDia: (dia?: string) => void
}

/** Troca o DIA do diário de pré-vendas direto no telão — o diário não tem período. */
export function SeletorDiaApresentacao({ dia, onDia }: SeletorDiaApresentacaoProps): ReactElement {
  const [aberto, setAberto] = useState(false)

  function escolher(escolhido?: Date): void {
    onDia(escolhido ? toDateOnly(escolhido) : undefined)
    setAberto(false)
  }

  return (
    <div
      role="group"
      aria-label="Dia do diário"
      className="border-border bg-card/70 flex items-center gap-1 rounded-full border p-1"
    >
      <button type="button" onClick={() => escolher(undefined)} aria-pressed={!dia} className={pilula(!dia)}>
        Hoje
      </button>
      <Popover open={aberto} onOpenChange={setAberto}>
        <PopoverTrigger asChild>
          <button
            type="button"
            aria-pressed={Boolean(dia)}
            className={cn(pilula(Boolean(dia)), 'flex items-center gap-2')}
          >
            <CalendarDays className="h-4 w-4" aria-hidden />
            {dia ? diaCurto(dia) : 'Escolher dia'}
          </button>
        </PopoverTrigger>
        <PopoverContent align="center" side="top" className="w-auto p-0">
          <Calendar
            mode="single"
            selected={dia ? parseLocalDate(dia) : undefined}
            // Abre no mês do dia escolhido — sem isso o popup cai no mês
            // corrente e o dia selecionado fica fora da vista.
            defaultMonth={dia ? parseLocalDate(dia) : undefined}
            onSelect={(escolhido) => escolher(escolhido ?? undefined)}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}
